export default __webpack_public_path__ + "static/media/work4.e2121efb.png";